module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/275.3cf546f5.png";